import { dispatchSnackbarNegativeEvent, RouteLeavingGuard } from '@dreryk/react-components';
import { useDraftCreateCqrsCommand } from '@dreryk/react-draft';

import { visitTranslationKeys } from '../../../translations';
import { getDocumentTemplateDraftTag, getVisitDraftTag } from '../../../visit/visit.draft';
import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { ReferralToAnalyticalExaminationFormController } from './ReferralToAnalyticalExaminationForm/ReferralToAnalyticalExaminationForm.types';

type ReferralToAnalyticalExaminationRouteLeavingGuardProps = Pick<
   ReferralToAnalyticalExaminationFormController,
   'formState' | 'handleSubmitDraft'
> & {
   readonly visitId: number;
};

export const ReferralToAnalyticalExaminationRouteLeavingGuard = (
   props: ReferralToAnalyticalExaminationRouteLeavingGuardProps
): JSX.Element => {
   const { executeAsync: saveReferralToAnalyticalExaminationDraft } = useDraftCreateCqrsCommand({
      onUnexpectedError: () => {
         dispatchSnackbarNegativeEvent(visitTranslationKeys.draftSaveFail);
      },
   });
   return (
      <RouteLeavingGuard
         active={props.formState.isDirty}
         onLeave={props.handleSubmitDraft(async (values) =>
            saveReferralToAnalyticalExaminationDraft({
               token: getReferralDraftToken('referralToAnalyticalExamination', props.visitId),
               tags: [getVisitDraftTag(props.visitId), getDocumentTemplateDraftTag(props.visitId)],
               contents: values,
            })
         )}
         successMessage={referralTranslationKeys.referralDraftSaved}
         testId={'analyticalExamination'}
      />
   );
};
